"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountExists = accountExists;
exports.validEmail = validEmail;

require("./login.scss");

var _firebase = require("../firebase");

var _auth = require("firebase/auth");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function validEmail(email) {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

function accountExists(_x) {
  return _accountExists.apply(this, arguments);
}

function _accountExists() {
  _accountExists = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(email) {
    var methods;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!validEmail(email)) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return (0, _auth.fetchSignInMethodsForEmail)(_firebase.auth, email);

          case 3:
            methods = _context.sent;

            if (!(methods.length > 0)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", true);

          case 6:
            return _context.abrupt("return", false);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _accountExists.apply(this, arguments);
}